export default {
  language: 'Sprache',
  loadParser: 'Parser-Datei laden',
  uploadParser: 'Parser-Datei hochladen',
  loadSample: 'Beispieldaten laden',
  download: 'Parser-Datei herunterladen',
  imprint: 'Impressum',
  help: 'Hilfe',
  parser_repository: 'Parser Verzeichnis',
  welcome: {
    message: 'Willkommen! Neu hier? Starten Sie',
    here: 'hier'
  },
  repository: {
    helpText: 'Dieser Bereich ermöglicht es Ihnen, Parser-Konfigurationen aus dem Community-Repository zu laden',
    contributeText: 'Möchten Sie Ihren eigenen Parser teilen? Besuchen Sie das Repository für Informationen, wie Sie Ihre Konfigurationen beitragen können, um der Community zu helfen.'
  }
}